import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const FederalIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_34384_2062"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="19"
      >
        <path d="M0 0H19V19H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_34384_2062)">
        <path
          d="M2.83199 9.38206V13.046C2.83199 13.8063 3.4457 14.42 4.20598 14.42C4.96625 14.42 5.57997 13.8063 5.57997 13.046V9.38206C5.57997 8.62179 4.96625 8.00807 4.20598 8.00807C3.4457 8.00807 2.83199 8.62179 2.83199 9.38206ZM8.32795 9.38206V13.046C8.32795 13.8063 8.94167 14.42 9.70194 14.42C10.4622 14.42 11.0759 13.8063 11.0759 13.046V9.38206C11.0759 8.62179 10.4622 8.00807 9.70194 8.00807C8.94167 8.00807 8.32795 8.62179 8.32795 9.38206ZM2.37399 19H17.0299C17.7902 19 18.4039 18.3863 18.4039 17.626C18.4039 16.8657 17.7902 16.252 17.0299 16.252H2.37399C1.61372 16.252 1 16.8657 1 17.626C1 18.3863 1.61372 19 2.37399 19ZM13.8239 9.38206V13.046C13.8239 13.8063 14.4376 14.42 15.1979 14.42C15.9582 14.42 16.5719 13.8063 16.5719 13.046V9.38206C16.5719 8.62179 15.9582 8.00807 15.1979 8.00807C14.4376 8.00807 13.8239 8.62179 13.8239 9.38206ZM8.85007 0.212969L1.61372 4.0235C1.23816 4.21586 1 4.60974 1 5.0311C1 5.66313 1.51296 6.17609 2.14499 6.17609H17.2681C17.8909 6.17609 18.4039 5.66313 18.4039 5.0311C18.4039 4.60974 18.1657 4.21586 17.7902 4.0235L10.5538 0.212969C10.0225 -0.0709895 9.38135 -0.0709895 8.85007 0.212969Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
})

FederalIcon.displayName = 'FederalIcon'
